
<div class="abstract-group mt-0"  >
    <f-title title="Ausführendes Unternehmen" />
    <div :class="background" class="pa-3 pt-2">
        <div v-if="!manufacturer">keine Angabe</div>

        <div style="min-height: 60px" v-if="manufacturer">
            <div class="abstract-title">
                {{ manufacturer.name }}
            </div>
            <div style="font-size: 12px;">
                {{ manufacturer.street }}
            </div>
            <div style="font-size: 12px;">
                {{ manufacturer.zip }} {{ manufacturer.city }}
            </div>
        </div>

        <div class="mt-2 v-flex space-between abstract-info-small">
            <div>
                <span class="primary--text">geplantes Ausführungsdatum</span>
                <span class="ml-1"  v-if="executionDate">{{ format ( executionDate ) }}</span>
                <span class="ml-1" v-if="!executionDate">keine Angabe</span>
            </div>
            <div v-if="deliverytime" >
                <span class="primary--text">Lieferzeit</span>
                <span class="ml-1">{{  deliverytime.name }}</span>
            </div>
        </div>
    </div>
</div>
